import store from '@/store'
import { snapshot } from 'valtio'
import { useNavigate } from 'react-router-dom'

const useCustomRouter = () => {
  const navigate = useNavigate()

  const push = (url: string, options?: { replace?: boolean }) => {
    store.status.lastPage = window.location.href

    const urlObj = new URL(url, window.location.href)
    const queryParams = new URLSearchParams(urlObj.search)

    queryParams.forEach((value, key) => {
      urlObj.searchParams.set(key, value)
    })

    if (!urlObj.searchParams.has('storeName')) {
      const storeName = snapshot(store).currentUser?.selectedCompany?.store_name
      if (storeName) {
        urlObj.searchParams.append('storeName', storeName)
      }
    }

    navigate(urlObj.pathname + urlObj.search + urlObj.hash, { replace: options?.replace })
  }

  return {
    push,
    replace: (url: string) => push(url, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => navigate(0),
  }
}

export default useCustomRouter
